export default __webpack_public_path__ + "static/media/decor-card.18962c6b.svg";